module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLinkVisible(_vm.row, _vm.query)) ? _c('div', {
    staticClass: "float-style"
  }, [(_vm.isExternal) ? _c('a', {
    attrs: {
      "href": _vm.getUrl,
      "target": "_blank"
    }
  }, [(_vm.title) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.title)),
      expression: "t(title)",
      arg: "tooltip"
    }],
    class: _vm.externalIconClass,
    style: ({
      'background-color': _vm.getIconColor
    })
  }) : _c('span', {
    class: _vm.externalIconClass,
    style: ({
      'background-color': _vm.getIconColor
    })
  })]) : _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [(_vm.title) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.title)),
      expression: "t(title)",
      arg: "tooltip"
    }],
    class: _vm.internalIconClass,
    style: ({
      'background-color': _vm.getIconColor
    })
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.internalIconClass,
    style: ({
      'background-color': _vm.getIconColor
    })
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6519a780!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/EmbeddedModuleComponent.vue
// module id = 1311
// module chunks = 2